// src/CiqlerDetail.js
import React, { useState } from "react";
import "./ciqler.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function CiqlerDetail() {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <div>
      <nav className="navbar">
        <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
          <h1>Ziad Aly</h1>
        </Link>
      </nav>
      <div className="ciqlerproject-detail notion-style">
        <div className="ciqler-video-container">
          <video
            controls
            width="100%"
            src={`${process.env.PUBLIC_URL}/./ciqler_engine_for_gifts.mp4`}
          />
        </div>
        <div className="detail-content">
          <div className="text-container">
            <h1>Ciqler</h1>
            <div className="projectImagec">
          <img
            src={`${process.env.PUBLIC_URL}/Ciqler_logo.png`}
            alt="Reporting Tool project"
          />
        </div>
            <p>
              Ciqler is a search engine designed specifically for gifts,
              utilizing advanced algorithms to match users with the perfect
              gifts based on their preferences and interests.
            </p>
            <h2>Founding Story</h2>
            <div>
              {/* First Three Orders */}
              <h3>First Three Orders</h3>
              <p>
                For two weeks, I started coding the MVP to validate if we could
                generate revenue using the Amazon API. I asked friends and
                family about their Amazon wishlist and coded a simple interface
                displaying iframes of products via Amazon Partner. After
                deploying the iframes through AWS CloudFront and S3, I sent them
                to product requesters, resulting in three initial orders and
                affiliate commission earnings
                <span
                  onClick={handleToggle}
                  style={{ color: "blue", cursor: "pointer" }}
                >
                  {expanded ? "" : "...more"}
                </span>
              </p>

              {/* Expanded content */}
              {expanded && (
                <>
                  {/* Images section */}
                  <div className="image-row" style={{ marginTop: "20px" }}>
                    <img
                      className="ciqlerimg1"
                      style={{ width: "50%", height: "600px" }}
                      src={`${process.env.PUBLIC_URL}/ciqler1.jpeg`}
                      alt="Initial Orders Screenshot"
                    />
                    <img
                      className="ciqlerimg2"
                      style={{
                        width: "50%",
                        height: "220px",
                        marginBottom: "380px",
                      }}
                      src={`${process.env.PUBLIC_URL}/ciqler2.jpeg`}
                      alt="Initial Orders Screenshot"
                    />
                  </div>
                  <h3>Open AI is not Operating in Egypt Yet</h3>
                  <p>
                    Our initial idea needed a pivot as ChatGPT wasn't available
                    in Egypt. I began coding the backend and creating an API to
                    post gifts to MongoDB. I reached out to my friend Mo, a
                    Somali immigrant in Egypt with a marketing background, who
                    helped add gifts to the database, annotating each item with
                    empathy-based tags, gender, and age ranges. Meanwhile, I
                    developed the front and back end.
                  </p>

                  <h3>Yasser Joining</h3>
                  <p>
                    While driving, I showed Yasser the Ciqler prototype and
                    asked for his feedback on the design. Yasser, energetic and
                    creative, was excited to contribute and improve the
                    aesthetics.
                  </p>
                  <video
                    controls
                    width="100%"
                    src={`${process.env.PUBLIC_URL}/ciqlerv1.mp4`}
                  />

                  <h3>6 Hours Business, 6 Hours Tech</h3>
                  <p>
                    Yasser and I committed to half-day business tasks, like
                    refining accelerator questions, and half-day tech work on
                    various tasks.
                  </p>

                  <h3>Finding the Matching Products</h3>
                  <p>
                    As Yasser worked on design, I focused on improving the
                    recommendation algorithm. The model began as a simple text
                    matching system and gradually evolved, adding NLP tools like
                    WordNet for synonym matching. I reached out to Dalia, a
                    former colleague in NLP, and she introduced me to Eslam, who
                    eventually became our AI officer and co-founder. Eslam
                    helped fine-tune a text2vec model, which we deployed using
                    AWS Lambda and ECS. We processed product and user data as
                    vectors in OpenSearch for high-accuracy matching.
                  </p>

                  <h3>Commercial Pipeline</h3>
                  <p>
                    With Mo's departure, product addition slowed, so we sought a
                    more efficient approach. Mariam, an ambitious collaborator,
                    designed a commercial pipeline, automating product listings
                    and annotations in Excel with a Python script deployed on
                    AWS Lambda.
                  </p>
                </>
              )}
            </div>
            <div>
              <h2>Technology</h2>
              <ul>
                <li> <strong>OpenSearch</strong> Vector DB</li>
                <li><strong>MongoDB</strong> Transcational DB</li>
                <li>
                  <strong> Python:</strong> Spark, Pandas, Spacy, Sentence-Transformers, NLTK, Tensorflow
                </li>
                <li>
                  NodeJs
                </li>
                <li>Reactjs</li>
                <li>Docker</li>
                <li>Google AI APIS</li>
                <li>
                  <strong>AWS:</strong> S3, EC2, CloudFront, Lambda Function, ECR, Glue, Event Bridge,
                   Rekognition, Comprehend, Route 53, SAM
                </li>
                <li>Azure DevOps</li>
              </ul>
              <h2>Team</h2>
              <a
                href="https://www.linkedin.com/company/90967489/admin/dashboard/"
                style={{ marginLeft: "25px", color: "inherit" }}
                rel="noopener noreferrer"
              >
                Ciqler
              </a>
            </div>
            <h2>Status</h2>
            <p style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  width: "8px",
                  height: "8px",
                  backgroundColor: "green",
                  borderRadius: "50%",
                  display: "inline-block",
                  marginRight: "8px",
                }}
              ></span>
            Online, Currently serving over 50 users Monthly, with continuous development in progress. </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CiqlerDetail;
